import type { Messages } from "./ru";

/** Kazakh UI copy. Same shape as ru.ts; studio data (service names, policies) stays as the studio wrote it. */
export const kk: Messages = {
  common: {
    loading: "Жүктелуде",
    retry: "Қайталау",
    back: "Артқа",
    close: "Жабу",
    cancel: "Бас тарту",
    confirm: "Растау",
    next: "Әрі қарай",
    notLoaded: "Жүктеу мүмкін болмады",
    notSaved: "Сақталмады",
    demo: "демо",
  },
  lang: { label: "Тіл", ru: "Рус", kk: "Қаз" },
  nav: {
    clientLabel: "Студия бөлімдері",
    home: "Басты бет",
    services: "Қызметтер",
    bookings: "Жазылулар",
    assistant: "Көмекші",
    studio: "Студия",
    ownerLabel: "Кабинет",
    day: "Күн",
    newBooking: "Жазу",
    stats: "Статистика",
    more: "Тағы",
  },
  studio: {
    demoTitle: "Демо-студия",
    demoText: "Мұндағы жазылулар демонстрациялық, хабарландырулар жіберілмейді.",
    previewTitle: "Алдын ала қарау",
    previewText: "Студия әлі іске қосылмаған: жазылулар сынақ ретінде белгіленеді және іске қосқанда жойылады.",
    notConfigured: "Қосымша бапталмаған",
    missingEnv: (v: string) => `Орта айнымалылары берілмеген: ${v}`,
    loading: "Студия жүктелуде",
    unavailable: "Студия қолжетімсіз",
  },
  notFound: {
    pageTitle: "Бет табылмады",
    pageText: "Мұндай бөлім жоқ.",
    toHome: "Студияның басты бетіне",
    linkTitle: "Студия сілтемесін ашыңыз",
    linkText: "Онлайн-жазылу мекенжайы былай көрінеді: /s/студия-атауы/",
  },
  price: {
    onRequest: "Бағасы сұраныс бойынша",
    from: (v: string) => `${v} бастап`,
    byStudio: "Студия нақтылайды",
  },
  duration: {
    days: (d: string) => `${d} тәулік`,
    minutes: (m: number) => `${m} мин`,
    hours: (h: number) => `${h} сағ`,
    hoursMinutes: (h: number, m: number) => `${h} сағ ${m} мин`,
  },
  home: {
    book: "Жазылу",
    upcoming: "Жақын жазылуыңыз",
    services: "Қызметтер",
    allServices: "Барлық қызметтер",
    noServicesTitle: "Қызметтер жақында пайда болады",
    noServicesText: "Студия каталогты әлі баптап жатыр. Жазылу үшін қоңырау шалыңыз.",
    works: "Жұмыстар",
    directions: "Бағыттар",
    findUs: "Бізді қалай табуға болады",
    todayHours: (h: string) => `Бүгін ашық: ${h}`,
    closedToday: "Бүгін демалыс",
    whatsapp: "WhatsApp-қа жазу",
    instagram: "Біздің Instagram",
    route: "Бағыт",
  },
  services: {
    title: "Қызметтер",
    category: "Санат",
    all: "Барлығы",
    emptyCategory: "Бұл санатта қызмет жоқ",
  },
  booking: {
    steps: { service: "Қызметті таңдаңыз", time: "Күні мен уақыты", contacts: "Байланыс деректеріңіз", review: "Жазылуды тексеріңіз" },
    stepOf: (i: number, total: number) => `${total} қадамның ${i}-сі`,
    closeLabel: "Жазылуды жабу",
    service: "Қызмет",
    when: "Қашан",
    duration: "Ұзақтығы",
    price: "Құны",
    contacts: "Байланыс",
    slotTakenTitle: "Уақыт бос емес",
    notCreated: "Жазылу жасалмады",
    otherTime: "Басқа уақыт",
    sending: "Жазып жатырмыз…",
    resend: "Қайта жіберу",
    submit: "Жазылу",
    editContacts: "Байланысты өзгерту",
  },
  time: {
    dateChoice: "Күнді таңдау",
    noFreeSuffix: ", бос уақыт жоқ",
    loadingSlots: "Бос уақыт жүктелуде",
    noFreeTitle: "Бос уақыт жоқ",
    pickOtherDay: "Басқа күнді таңдаңыз.",
    freeTime: "Бос уақыт",
    multiDay: (days: number) => `Бұл – қабылдау уақыты. Жұмыс ${days} тәулікке созылады, аяқталған соң береміз.`,
    tzNote: (tz: string) => `Уақыт студияның уақыт белдеуі бойынша көрсетілген (${tz}).`,
  },
  contacts: {
    name: "Аты",
    phone: "Телефон",
    phoneHint: "Бірдеңе өзгерсе, студия қоңырау шалады",
    email: "E-mail",
    comment: "Пікір",
    errName: "Атыңызды жазыңыз",
    errPhone: "7–15 цифрдан тұратын нөмір, + белгісімен болады",
    errEmail: "E-mail-ді тексеріңіз",
    errComment: "500 таңбадан аспауы керек",
  },
  my: {
    title: "Менің жазылуларым",
    emptyTitle: "Мұнда жазылуларыңыз пайда болады",
    emptyText: "Жазылулар осы құрылғыда сақталады. Басқа телефоннан жазылған болсаңыз, растаудағы сілтемені ашыңыз.",
    upcoming: "Алдағы",
    past: "Өткен",
    forget: "Осы құрылғыдағы жазылуларды ұмыту",
  },
  bookingPage: {
    title: "Жазылу",
    booked: "Сіз жазылдыңыз",
    incompleteTitle: "Сілтеме толық емес",
    incompleteText: "Жазылу сілтемесін толық ашыңыз – онда қолжетімділік кілті бар.",
    confirmedTitle: "Жазылу расталды",
    confirmedText: "Осы бетті сақтаңыз: сілтеме арқылы жазылуды тіркелусіз ауыстыруға немесе болдырмауға болады.",
    status: { confirmed: "Расталды", completed: "Аяқталды", cancelled: "Болдырылмады", no_show: "Келмеді" },
    address: "Мекенжай",
    copy: "Жазылу сілтемесін көшіру",
    copied: "Сілтеме көшірілді",
    reschedule: "Ауыстыру",
    cancel: "Жазылудан бас тарту",
    cantChange: (hours: number, phone: string) => `Жазылуды онлайн өзгерту енді мүмкін емес (басталуына ${hours} сағаттан аз қалды). Қоңырау шалыңыз: ${phone}`,
    cancelFailed: "Бас тарту мүмкін болмады",
    cancelQuestion: "Жазылудан бас тартасыз ба?",
    cancelText: (what: string) => `${what}. Уақыт басқаларға босайды.`,
    keep: "Қалдыру",
  },
  notify: {
    ics: "Күнтізбеге арналған файлды жүктеу (.ics)",
    icsSaved: "Файл жүктелді. Күнтізбе оқиғаны 2 сағат бұрын еске салумен қосуы үшін оны ашыңыз. Ауыстырғаннан кейін файлды қайта жүктеңіз.",
    icsHint: "Күнтізбеңізді өзіміз өзгертпейміз – оқиғаны файлдан өзіңіз қосасыз.",
    icsDescription: (url: string) => `Жазылу: ${url}`,
    pushOn: "Осы құрылғыға еске салғыштар қосылған.",
    disable: "Өшіру",
    enable: "Осы құрылғыда еске салғыштарды қосу",
    demo: "Бұл демо-жазылу: студия ол бойынша хабарландыру жібермейді.",
    failedTitle: "Еске салғыштар қосылмады",
    permissionDenied: "Рұқсат берілмеді.",
  },
  reschedule: {
    title: "Жазылуды ауыстыру",
    now: (v: string) => `Қазір: ${v}`,
    serviceGoneTitle: "Қызмет енді онлайн қолжетімсіз",
    serviceGoneText: "Жазылуды ауыстыру үшін студияға қоңырау шалыңыз.",
    newTime: (v: string) => `Жаңа уақыт: ${v}`,
    failed: "Ауыстырылмады",
    keptSuffix: "Ағымдағы жазылу сақталды.",
    confirm: "Осы уақытқа ауыстыру",
    pickOther: "Басқасын таңдау",
  },
  about: {
    call: (phone: string) => `Қоңырау шалу: ${phone}`,
    map: "Картадан ашу",
    website: "Сайт",
    hours: "Жұмыс уақыты",
    contacts: "Байланыс",
    write: "Жазу",
    directions: "Қалай жетуге болады",
    route: "Бағыт құру",
    mapTitle: (address: string) => `Карта: ${address}`,
    dayOff: "демалыс",
    address: "Мекенжай",
    tz: (tz: string) => `Студияның уақыт белдеуі: ${tz}`,
    rules: "Ережелер",
  },
  install: {
    title: "Басты экрандағы белгіше",
    install: (name: string) => `«${name}» басты экранға қосу`,
    ios: "«Бөлісу», содан кейін «„Басты“ экранға» түймесін басыңыз – сайт кәдімгі белгіше сияқты бір басумен ашылады. iPhone-да еске салғыштар сайт «Басты» экранға қосылғанда ғана келеді.",
    other: "Браузер мәзірін (⋮) ашып, «Басты экранға қосу» тармағын таңдаңыз.",
  },
  pwa: {
    notConfigured: "Бұл студия үшін хабарландырулар бапталмаған.",
    iosHome: "iPhone-да хабарландырулар сайт «Басты» экранға қосылғанда ғана келеді: «Бөлісу» → «„Басты“ экранға» (iOS 16.4+).",
    unsupported: "Бұл браузер push-хабарландыруларды қолдамайды.",
    denied: "Браузер баптауларында бұл сайт үшін хабарландыруларға тыйым салынған.",
  },
  assistant: {
    title: "Көмекші",
    noConnection: "Көмекшімен байланыс жоқ.",
    unavailable: "Көмекші қазір қолжетімсіз.",
    disabled: "Бұл студияда көмекші өшірілген.",
    tooMany: "Сұрақтар тым көп. Бірнеше минуттан кейін қайталаңыз.",
    noAccess: "Қолжетімділік жоқ: кабинетке қайта кіріңіз.",
    failed: (status: number) => `Көмекші қатесі (${status}).`,
    placeholderOwner: "Мысалы: аптада қанша ақша түсті?",
    placeholderClient: "Мысалы: сенбіде қашан бос?",
    emptyOwner: "Жазылулар, бос уақыт немесе статистика туралы сұраңыз. Жауаптар студия деректеріне негізделеді.",
    emptyClient: "Қызметтер, бағалар, бос уақыт немесе жазылуыңыз туралы сұраңыз.",
    thinking: "Көмекші студия деректерін қарап жатыр…",
    unavailableTitle: "Көмекші қолжетімсіз",
    bookingWorks: "Жазылу әдеттегідей жұмыс істейді.",
  },
  errors: {
    slot_unavailable: "Бұл уақытты жаңа ғана біреу алып қойды. Басқасын таңдаңыз.",
    slot_not_offered: "Бұл уақытқа жазылу мүмкін емес.",
    studio_not_found: "Студия табылмады немесе әлі жарияланбаған.",
    service_not_found: "Қызмет енді қолжетімсіз.",
    booking_not_found: "Жазылу табылмады. Сілтемені тексеріңіз.",
    booking_not_active: "Жазылу бұрыннан болдырылмаған немесе аяқталған.",
    change_window_closed: "Жазылуды онлайн өзгерту енді мүмкін емес – студияға қоңырау шалыңыз.",
    invalid_phone: "Телефон нөмірін тексеріңіз.",
    invalid_name: "Атыңызды жазыңыз.",
    comment_too_long: "Пікір тым ұзын.",
    rate_limited: "Әрекеттер тым көп. Біраз күтіп, қайталаңыз.",
    idempotency_key_reused: "Жіберу кезінде деректер өзгерді. Қайтадан көріңіз.",
    forbidden: "Бұл студияға қолжетімділік жоқ.",
    not_authenticated: "Кабинетке кіріңіз.",
    block_conflicts: "Бұл уақытта жазылулар бар.",
    invalid_range: "Кезеңнің басы мен соңын тексеріңіз.",
    resource_not_suitable: "Бұл ресурс бұл қызметті орындамайды.",
    payment_in_future: "Төлемді болашақ күнмен жазуға болмайды.",
    booking_in_future: "Келу әлі басталған жоқ.",
    invalid_amount: "Соманы тексеріңіз.",
    invalid_period: "Кезең дұрыс емес.",
    media_managed_by_config: "Бұл фото студия конфигурациясынан – ол жариялау арқылы өзгертіледі.",
    invalid_media_path: "Фотоны сақтау мүмкін болмады.",
    network: "Сервермен байланыс жоқ. Интернетті тексеріңіз.",
    unknown: "Бірдеңе дұрыс болмады. Қайталап көріңіз.",
  },
  login: {
    title: "Кабинетке кіру",
    method: "Кіру тәсілі",
    byPhone: "Телефон",
    byEmail: "Пошта",
    phone: "Телефон нөмірі",
    phoneHint: "Кабинетке байланған нөмір. Кодты SMS арқылы жібереміз.",
    email: "E-mail",
    emailHint: "Қолжетімділік берілген пошта. Кодты хатпен жібереміз.",
    sendCode: "Код алу",
    code: "6 цифрлық код",
    codeSentPhone: (dest: string) => `${dest} нөміріне кодпен SMS жібердік.`,
    codeSentEmail: (dest: string) => `${dest} поштасына хат жібердік. Ондағы кіру сілтемесін басыңыз немесе хатта код болса, оны төменге енгізіңіз. Хат болмаса, спамды тексеріңіз.`,
    verify: "Кіру",
    resend: "Кодты қайта жіберу",
    resendIn: (s: number) => `Қайта жіберу – ${s} с кейін`,
    change: "Нөмірді немесе поштаны өзгерту",
    failed: "Кіру мүмкін болмады",
    notInvited: "Бұл нөмір немесе e-mail кабинетке шақырылмаған.",
    badCode: "Код қате немесе ескірген. Жаңасын сұраңыз.",
    badPhone: "Нөмірді тексеріңіз: кемінде 10 цифр, + белгісімен болады.",
    smsUnavailable: "SMS жіберу бапталмаған. Пошта арқылы кіріңіз.",
    tooOften: "Код жіберілді. Бір минут күтіп, қайталаңыз.",
    footer: "Құпиясөз қажет емес. Қолжетімділікті платформа әкімшісі береді, тіркелу жоқ.",
  },
  owner: {
    checking: "Кіруді тексеріп жатырмыз",
    loading: "Кабинет жүктелуде",
    noAccessTitle: "Қолжетімділік жоқ",
    noAccessText: (account: string) => `${account} аккаунты бұл студияның иесі емес.`,
    logout: "Шығу",
  },
  day: {
    today: "Бүгін",
    block: "Бұғат",
    prev: "Алдыңғы күн",
    next: "Келесі күн",
    toToday: "Бүгінгі күнге",
    summary: (n: number, money: string) => `${n} белсенді жазылу · күтілетін құны ${money} (бұл түсім емес)`,
    emptyTitle: "Жазылулар жоқ",
    emptyText: "Бос күн.",
    add: "Жазылу қосу",
    blockLabel: "Бұғаттау",
    status: { cancelled: "Болдырылмады", completed: "Орындалды", no_show: "Келмеді" },
  },
  ownerBooking: {
    title: "Жазылу",
    notFound: "Бұл күнде жазылу табылмады",
    toSchedule: "Кестеге",
    client: "Клиент",
    phone: "Телефон",
    service: "Қызмет",
    start: "Басталуы",
    end: "Аяқталуы",
    resource: "Ресурс",
    price: "Жазылудағы баға",
    paid: "Алынды",
    comment: "Пікір",
    call: "Қоңырау шалу",
    write: "Жазу",
    move: "Ауыстыру",
    done: "Орындалды",
    noShow: "Келмеді",
    cancel: "Болдырмау",
    markAfterStart: "Келуді ол басталғаннан кейін белгілеуге болады.",
    payment: "Төлем",
    paymentHint: "Іс жүзінде алынған ақшаны жазыңыз. Қайтарым – теріс сомамен.",
    amount: "Сома",
    method: "Тәсіл",
    card: "Карта",
    cash: "Қолма-қол",
    transfer: "Аударым",
    payFailed: "Төлем жазылмады",
    recordPayment: "Төлемді жазу",
    cancelQuestion: "Жазылуды болдырмайсыз ба?",
    doneQuestion: "Орындалды деп белгілейсіз бе?",
    noShowQuestion: "Келмеді деп белгілейсіз бе?",
    cancelText: "Уақыт босайды, клиентке хабарландыру барады (егер ол қосқан болса).",
    statusText: "Мәртебе бүгінгі статистикаға түседі.",
    cancelAction: "Жазылуды болдырмау",
  },
  newBooking: {
    title: "Жаңа жазылу",
    service: "Қызмет",
    pickService: "Қызметті таңдаңыз",
    clientName: "Клиенттің аты",
    phone: "Телефон",
    comment: "Пікір",
    submit: "Жазу",
    needNamePhone: "Аты мен телефонын жазыңыз",
  },
  slotPicker: {
    day: "Күн",
    picked: (v: string) => `Таңдалды: ${v}`,
    failed: "Орындалмады",
  },
  block: {
    titleExisting: "Бұғаттау",
    titleNew: "Уақытты бұғаттау",
    removeFailed: "Алып тастау мүмкін болмады",
    remove: "Бұғаттауды алу",
    what: "Нені бұғаттаймыз",
    pick: "Таңдаңыз",
    from: "Бастап",
    to: "Дейін",
    time: "Уақыт",
    reason: "Себебі",
    reasonPlaceholder: "Қызмет көрсету, демалыс…",
    conflictTitle: "Жазылулармен қиылысады",
    submit: "Бұғаттау",
    tzNote: (tz: string) => `Уақыт студияның уақыт белдеуі бойынша (${tz}).`,
  },
  stats: {
    title: "Статистика",
    period: "Кезең",
    periods: { today: "Бүгін", yesterday: "Кеше", week: "Апта", month: "Ай", last_7_days: "7 күн", last_30_days: "30 күн" },
    demoTitle: "Деректерде демо-жазылулар бар",
    demoText: "Олар студияны іске қосқанда жойылады.",
    received: "Түскен ақша",
    receivedHint: (n: number) => `${n} төлем – бұл түсім`,
    completed: "Орындалған тапсырыс",
    completedHint: (v: string) => `жазылу бағасы бойынша ${v}`,
    visits: "Келулер",
    visitsHint: "клиент келді (басталған жазылулар)",
    upcoming: "Алда",
    upcomingHint: (v: string) => `${v} күтіледі – түсім емес`,
    cancelled: "Болдырылмағандар",
    noShow: "Келмегендер",
    forPeriod: "кезең ішінде",
    top: "Танымал қызметтер",
  },
  settings: {
    title: "Тағы",
    blocks: "Бұғаттаулар мен бос тұру",
    blocksText: "Шеберді немесе жұмыс орнын уақытша жабу",
    photos: "Фотолар",
    photosText: "Жұмыстарыңыздың фотолары және мұқаба",
    assistant: "Көмекші",
    assistantText: "Жазылулар мен статистика туралы сұрақтар",
    openClient: "Клиент бетін ашу",
    pushTitle: "Жаңа жазылулар туралы хабарландырулар",
    disableHere: "Осы құрылғыда өшіру",
    enableHere: "Осы құрылғыда қосу",
    notLive: "Студия іске қосылмайынша хабарландырулар жіберілмейді.",
    notEnabled: "Қосылмады",
    launch: "Студияны іске қосу",
    live: "Студия жұмыс істеп тұр: жазылулар шынайы, хабарландырулар жіберіледі.",
    mustFix: "Іске қосар алдында түзету керек",
    ready: (n: number) => `Бәрі дайын. Іске қосқанда ${n} сынақ жазылуы жойылады; фотолар мен баптаулар қалады.`,
    notLaunched: "Іске қосылмады",
    launchAction: "Студияны іске қосу",
    logout: "Кабинеттен шығу",
    problems: {
      no_active_services: "Орындаушылары бар белсенді қызметтер жоқ",
      no_working_hours: "Жұмыс уақыты берілмеген",
      no_contact_phone: "Телефон көрсетілмеген",
      no_address: "Мекенжай көрсетілмеген",
      demo_config: "Бұл демо-студия – оны іске қосуға болмайды",
      config_needs_review: "business.json-да тексерілмеген тармақтар бар (review_notes)",
      no_owner: "Иесі жоқ",
    },
  },
  photos: {
    title: "Фотолар",
    photo: "Фото",
    photoHint: "8 МБ-қа дейінгі JPG, PNG немесе WebP",
    service: "Қызмет",
    pickService: "Қай қызметке",
    pickServicePlaceholder: "Қызметті таңдаңыз",
    forService: (name: string) => `Қызмет: ${name}`,
    rules: "Сіздің фотоларыңыз сайттағы мысалдарды ауыстырады: мұқаба мен қызмет фотосы – бірден, ал «Жұмыстарда» кемінде біреуі жүктелген соң тек сіздің фотоларыңыз көрсетіледі. Өз фотоңызды жойсаңыз – мысал қайтады.",
    mine: "Сіздің фотоларыңыз",
    where: "Қайда",
    gallery: "Галерея",
    cover: "Мұқаба",
    alt: "Көзі көрмейтіндерге арналған сипаттама",
    notUploaded: "Жүктелмеді",
    upload: "Жүктеу",
    emptyTitle: "Өз фотоларыңыз әлі жоқ",
    emptyText: "Әзірге сайтта мысалдар. Өз фотоларыңызды жүктеңіз – олар бірден ауыстырады.",
    delete: "Жою",
    notDeleted: "Жойылмады",
  },
};
